import React from "react";
import { Helmet } from "react-helmet";
import { FaDownload, FaFilePdf } from "react-icons/fa";

function AdmissionProcess() {
  return (
		<>
			<Helmet>
				<title>Admission Process | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="AdmissionHeader HeaderImg">
					<img
						src="/Images/Banner/AdmissionProcess.png"
						alt="admission-banner"
					/>
				</div>

				<div id="Heading" data-aos="fade-up">
					<h1>Admission Process</h1>
				</div>

				{/* Prospectus Download Section */}
				<div
					className="Section"
					style={{
						marginBottom: "45px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
					data-aos="fade-up"
				>
					<div id="Secondary_Heading" style={{ width: "100%", marginBottom: "20px" }}>
						<h3>Prospectus</h3>
					</div>

					<div
						style={{
							width: "100%",
							maxWidth: "750px",
							background: "#ffffff",
							border: "1px solid #e2e8f0",
							borderRadius: "12px",
							padding: "30px 24px",
							boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							textAlign: "center",
							gap: "18px",
						}}
					>
						<div
							style={{
								width: "60px",
								height: "60px",
								borderRadius: "50%",
								backgroundColor: "#fee2e2",
								color: "#dc2626",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "28px",
							}}
						>
							<FaFilePdf />
						</div>

						<div>
							<h4
								style={{
									fontSize: "20px",
									fontWeight: "700",
									color: "#1e293b",
									marginBottom: "8px",
								}}
							>
								Prospectus (4 Years Integrated B.A. / B.Sc.-B.Ed.)
							</h4>
							<p
								style={{
									color: "#64748b",
									fontSize: "15px",
									lineHeight: "1.6",
									maxWidth: "540px",
									margin: "0 auto",
								}}
							>
								Download the official prospectus to check comprehensive information regarding admission guidelines, eligibility criteria, seat matrix, and curriculum.
							</p>
						</div>

						<a
							href="/Prospectus.pdf"
							download="Prospectus.pdf"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								cursor: "pointer",
								marginTop: "8px",
								padding: "12px 30px",
								backgroundColor: "#0038A3",
								color: "#ffffff",
								borderRadius: "6px",
								fontWeight: "600",
								fontSize: "15px",
								display: "inline-flex",
								alignItems: "center",
								gap: "10px",
								boxShadow: "0 3px 10px rgba(0, 56, 163, 0.25)",
								transition: "all 0.2s ease-in-out",
							}}
							onMouseOver={(e) => {
								e.currentTarget.style.backgroundColor = "#002b80";
								e.currentTarget.style.transform = "translateY(-1px)";
							}}
							onMouseOut={(e) => {
								e.currentTarget.style.backgroundColor = "#0038A3";
								e.currentTarget.style.transform = "translateY(0)";
							}}
						>
							<FaDownload />
							Download Prospectus
						</a>
					</div>
				</div>

				{/* ITEP Section */}
				<div className="Section" style={{ marginBottom: "40px" }} data-aos="fade-up">
					<div id="Secondary_Heading">
						<h3>ITEP (Integrated Teacher Education Programme) Foundation</h3>
					</div>
					<p style={{ marginBottom: "20px", lineHeight: "1.7", fontSize: "16px", color: "#333" }}>
						ITEP is a 4 year dual major holistic undergraduate degree offering B.A. B.Ed / B.Sc. B.Ed and B.Com. B.Ed. This course will prepare teachers for the foundational stages.
					</p>

					<div className="CourseTable">
						<table>
							<tbody>
								<tr>
									<td style={{ fontWeight: "600", width: "25%" }}>Course -</td>
									<td>ITEP (Foundation)</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Recognizing Body -</td>
									<td>Recognised by the National Council for Teacher Education (NCTE)</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Duration -</td>
									<td>4 years (Integrated undergraduate degree)</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>No. of Semesters -</td>
									<td>8 Semesters</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Total Intake / Seats -</td>
									<td>
										3 Units:
										<ul style={{ marginTop: "5px", paddingLeft: "20px", listStyleType: "disc" }}>
											<li>01 Unit B.A. B.Ed.</li>
											<li>01 Unit B.Sc. B.Ed.</li>
											<li>01 Unit B.Com. B.Ed.</li>
										</ul>
									</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Affiliation -</td>
									<td>Vinoba Bhave University, Hazaribagh</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Eligibility -</td>
									<td>10+2 or equivalent examination from a recognized board / Jharkhand board</td>
								</tr>
								<tr>
									<td style={{ fontWeight: "600" }}>Admission Procedure -</td>
									<td>
										Through National Testing Agency (NTA) through the National Common Entrance Test (NCET)
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>


			</div>
		</>
	);
}

export default AdmissionProcess;
